import { ProgressSpinner } from 'primereact/progressspinner';

//i18n
import { withTranslation } from "react-i18next";

//css
import '@assets/css/progressspinner.css';

function Loading({ t }) {
  return (
	<section>
		<div className="container">
			<div className="row align-items-center">
				<div className="col-12">
					<ProgressSpinner style={{width: '50px', height: '50px'}} className="brj-spinner" strokeWidth="3" animationDuration="1.5s" aria-label={t("Die Seite lädt")+"..."} /> {t("Inhalte werden geladen")+"..."}
				</div>
			</div>
		</div>
	</section>
  );
}

export default withTranslation()(Loading);